<template>
  <div class="wrapper">
    <v-chart
      ref="chart"
      class="chart"
      autoresize
      :option="option"
      :theme="theme"
    />
  </div>
</template>

<script>
import { use } from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from 'echarts/components';
import VChart, { THEME_KEY } from 'vue-echarts';
import { mapState } from 'vuex';

use([
  SVGRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
]);

export default {
  name: 'PieEcharts',
  components: {
    VChart,
  },
  provide: {
    [THEME_KEY]: 'dark',
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      option: {
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b} : {c}€ ({d}%)',
          textStyle: {
            fontSize: 12,
          },
          valueFormatter: value => this.$options.filters.currency(value),
        },
        series: [
          {
            // name: 'Vuoden tuoton jakautuminen',
            type: 'pie',
            radius: ['20%', '70%'],
            roseType: 'radius',
            itemStyle: {
              borderRadius: 5,
            },
            data: [],
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      theme: 'theme',
    }),
  },
  watch: {
    data: {
      async handler() {
        this.setOption();
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.$bus.$on('resizeCharts', async () => {
      setTimeout(() => {
        this.$refs.chart.resize();
      }, 150);
    });
  },

  methods: {
    setOption() {
      this.option.series[0].data = this.data;
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrapper {
  height: 100%;
}
</style>
